// extracted by mini-css-extract-plugin
module.exports = {"fakeLink":"tst3jXEb","link":"ilC7zNNz"};